import { TOTAL_ONBOARDING_STEPS } from '../constants';
import type { WizardStep } from '../hooks/useOnboardingWizard';

interface OnboardingProgressProps {
  currentStep: WizardStep;
}

export default function OnboardingProgress({ currentStep }: OnboardingProgressProps) {
  const activeIndex = currentStep === 'completing' ? TOTAL_ONBOARDING_STEPS : Number(currentStep);
  const stepLabel = `${activeIndex} of ${TOTAL_ONBOARDING_STEPS}`;

  return (
    <div className="shrink-0 px-6 pb-2 pt-5">
      <p className="text-center text-xs font-medium tabular-nums text-gray-400">{stepLabel}</p>
      <div
        className="mt-2.5 flex min-w-0 items-center gap-1.5"
        role="progressbar"
        aria-valuenow={activeIndex}
        aria-valuemin={1}
        aria-valuemax={TOTAL_ONBOARDING_STEPS}
        aria-label={`Step ${stepLabel}`}
      >
        {Array.from({ length: TOTAL_ONBOARDING_STEPS }, (_, i) => {
          const stepNum = i + 1;
          const isActive = stepNum === activeIndex;
          const isComplete = stepNum < activeIndex;

          return (
            <div
              key={stepNum}
              className={`h-1 flex-1 rounded-full transition-colors duration-300 ${
                isComplete || isActive ? 'bg-emerald-600' : 'bg-gray-200'
              }`}
              aria-current={isActive ? 'step' : undefined}
            />
          );
        })}
      </div>
    </div>
  );
}
